import React, { useRef } from "react";
import Webcam from "react-webcam";

const WebcamCapture = ({ onCapture, onClose }) => {
  const webcamRef = useRef(null);

  // Capture the image from the webcam feed
  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    onCapture(imageSrc); // Pass the captured image to the parent component
  };

  // Constraints for the device's webcam
  const videoConstraints = {
    width: 640,
    height: 480,
    facingMode: "user", // Use "environment" for back cameras
  };

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Capture Your Photo</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose} // Close the modal
            ></button>
          </div>
          <div className="modal-body text-center">
            {/* Webcam Component */}
            <Webcam
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              style={{ width: "100%", height: "400px" }}
            />
            <button
              type="button"
              className="btn btn-primary mt-3"
              onClick={capture}
            >
              Capture Photo
            </button>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose} // Close the modal
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebcamCapture;
